import * as vp from 'vopay';

import { useState } from 'react';
import axios from 'axios';

import vopayApi from '../../services/api.config';
import { useDataFetchIndicator } from '..';

const initHook = vopayApi.withApiHook(({ api }) => {
  return function useRailzCreateBill() {
    const source = axios.CancelToken.source();

    const [response, setResponse] = useState<vp.ApiResponse>();

    const [, setDataFetchingInfo] = useDataFetchIndicator();

    const createBill = async (requestParams: vp.RailzCreateBillRequest) => {
      try {
        setDataFetchingInfo(true, 'loading some data', 'fullScreen');
        const res = await api.railzCreateBill(requestParams, source);
        setResponse(res);
        return res;
      } finally {
        setDataFetchingInfo(false);
      }
    };
    const reset = () => {
      setResponse(undefined);
    };

    return {
      response,
      createBill,
      reset,
    };
  };
});

export default initHook({});
